<mat-tab-group mat-stretch-tabs [dynamicHeight]="true">
  <mat-tab label="PROFILE">
    <br />
    <div *ngIf="(hasValidToken$ | async); else noValidToken">
      <div *ngIf="(decodedToken$ | async) as decodedToken">
        <div fxLayout="row" fxLayoutAlign="center center">
          <ngx-avatar [@rotatedState]='state' [name]="decodedToken?.firstName + ' ' + decodedToken?.surname" size="100"
            textSizeRatio="2"></ngx-avatar>
        </div>
        <div fxLayout="column" fxLayoutAlign="center center">
          <p>{{ decodedToken.firstName }} {{ decodedToken.surname }}</p>
          <p style="width:500px; text-align: center;">Roles: {{ decodedToken.roles.join(', ') }}</p>
          <p>Access expires {{ decodedToken.expires | amTimeAgo }}.</p>
        </div>
        <hr />
      </div>
      <mat-nav-list>
        <div fxLayout="row" fxLayoutAlign="space-evenly center">
          <mat-list-item><button fxFlex (click)="logout()" mat-button>LOGOUT</button></mat-list-item>
          <mat-list-item><button fxFlex (click)="close()" mat-button>CLOSE</button></mat-list-item>
        </div>
      </mat-nav-list>
    </div>

    <ng-template #noValidToken>
      <app-login (loginClicked)="login($event)" (forgotPasswordClicked)="forgotPassword()" (clearLastUserClicked)="clearLastUser()"
        [lastLoggedInUser]="lastLoggedInUser$ | async" [isLoading]="isLoading$ | async"></app-login>
    </ng-template>
  </mat-tab>
  <mat-tab label="SETTINGS">
    <br />
    <app-theme-switcher [theme]="theme$ | async" (selectThemeClicked)="selectTheme($event)" (closeClicked)="close()"></app-theme-switcher>
  </mat-tab>
</mat-tab-group>
